import styled from "styled-components";
import { Color } from "@/shared/Constants";

export const StarList = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    gap: 0.2rem;

    .stars {
        display: flex;
    }
    span.empty svg {
        fill: ${Color.greyE2E2E2};
    }
    span.active svg {
        fill: ${Color.grey};
    }

    .filled {
        svg {
            fill: #555555 !important;
        }
    }

    .half {
        svg {
            fill: rgb(145, 142, 142) !important;
        }
    }

    .empty {
        svg {
            fill: #dcdcdc !important;
        }
    }
`;
